import { useCallback } from 'react'
import { useDashIntl } from '../../../../intl/intl.hooks'
import { type DashTableIntlProps } from '../../../dash-blocks/dash-table/utils/dashTable.types'

export const useTableBehaviour = () => {
  const intl = useDashIntl()

  const pageSizeText = intl.formatMessage({ id: 'components.table.itemsPerPage' })

  const paginatorText: DashTableIntlProps['paginatorText'] = useCallback(
    ({ totalPageCount, pageIndex }: { totalPageCount?: number; pageIndex: number }) =>
      intl.formatMessage(
        { id: 'components.table.totalPages' },
        { pageCount: totalPageCount === undefined ? 'many' : totalPageCount }
      ),
    [intl]
  )

  const recordCountText: DashTableIntlProps['recordCountText'] = useCallback(
    ({ firstVisibleRecordIndex, lastVisibleRecordIndex, totalRecordCount }) =>
      intl.formatMessage(
        { id: 'components.table.itemCounts' },
        {
          from: totalRecordCount === 0 ? 0 : firstVisibleRecordIndex + 1,
          to: totalRecordCount === 0 ? 0 : lastVisibleRecordIndex + 1,
          count: totalRecordCount === undefined ? 'many' : totalRecordCount,
        }
      ),
    [intl]
  )

  const defaultErrorMessage = intl.formatMessage({ id: 'common.error' })

  return {
    pageSizeText,
    paginatorText,
    recordCountText,
    defaultErrorMessage,
  }
}
